"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var button_styles = __importStar(require("@components/Buttons/Button.module.scss"));
var form_styles = __importStar(require("./Modal.module.scss"));
var react_modal_1 = __importDefault(require("react-modal"));
var icons_1 = require("@assets/icons");
var modalSlice_1 = require("@store/slices/modalSlice");
var mechanicsTypeSlice_1 = require("@store/slices/mechanicsTypeSlice");
var mechanicsTypesAPI_1 = require("@services/mechanicsTypesAPI");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var useKeyEnter_1 = require("@hooks/useKeyEnter");
var useClearOnTime_1 = __importDefault(require("@hooks/useClearOnTime"));
function MechanicsTypeModal(_a) {
    var isVisibe = _a.isVisibe, setVisible = _a.setVisible, setMechanicsType = _a.setMechanicsType, currentType = _a.currentType;
    var types = (0, react_redux_1.useSelector)(function (state) { return state.mechanicsTypeSlice; }).types;
    var gddId = (0, react_redux_1.useSelector)(function (state) { return state.gddSlice.gdd; }).id;
    var _b = (0, react_1.useState)(""), errorMessage = _b[0], setErrorMessage = _b[1];
    var newTypeRef = (0, react_1.useRef)(null);
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, useKeyEnter_1.useKeyEnterWithInput)({
        func: function (e) { return handleAddType(e); },
        inputRef: newTypeRef,
    });
    (0, useClearOnTime_1.default)({ setText: setErrorMessage, text: errorMessage });
    /** Добавление типа */
    function handleAddType(typeName) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (types.some(function (type) { return type.type === typeName; })) {
                            setErrorMessage("Mechanic type already exists");
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, mechanicsTypesAPI_1.createMechnanicsTypeAPI)(typeName, gddId)];
                    case 2:
                        res = _a.sent();
                        if (!res.success) {
                            dispatch((0, modalSlice_1.showModal)({ activeModal: modalSlice_1.ActiveModal.Info, text: res.message }));
                            return [2 /*return*/];
                        }
                        dispatch((0, mechanicsTypeSlice_1.addMechanicType)(res.type));
                        setMechanicsType(res.type.id);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        dispatch((0, modalSlice_1.showModal)({ activeModal: modalSlice_1.ActiveModal.Info, text: error_1 }));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    /** Удаление типа */
    function handleDeleteType(type) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, mechanicsTypesAPI_1.deleteMechnanicsTypeAPI)(type.id)];
                    case 1:
                        res = _a.sent();
                        if (!res.success) {
                            dispatch((0, modalSlice_1.showModal)({ activeModal: modalSlice_1.ActiveModal.Info, text: res.message }));
                            return [2 /*return*/];
                        }
                        if (currentType === type.id) {
                            setMechanicsType("null");
                        }
                        dispatch((0, mechanicsTypeSlice_1.deleteMechanicType)(type.id));
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        dispatch((0, modalSlice_1.showModal)({ activeModal: modalSlice_1.ActiveModal.Info, text: error_2 }));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return ((0, jsx_runtime_1.jsx)(react_modal_1.default, { isOpen: isVisibe, ariaHideApp: false, style: {
            content: {
                border: "none",
                background: "none",
                overflow: "hidden",
                height: "100vh",
                transform: "none",
                position: "absolute",
            },
            overlay: {
                zIndex: 1000,
            },
        }, children: (0, jsx_runtime_1.jsxs)("div", { className: form_styles.submit_form, children: [(0, jsx_runtime_1.jsx)("h2", { children: "Types" }), (0, jsx_runtime_1.jsx)("div", { className: form_styles.form_group, children: (0, jsx_runtime_1.jsx)("input", { "data-testid": "types-modal-input-test", placeholder: "new", id: "new_type", name: "new_type", type: "text", ref: newTypeRef }) }), (0, jsx_runtime_1.jsx)("ul", { children: types.map(function (type) { return ((0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("span", { children: type.type }), (0, jsx_runtime_1.jsx)("button", { className: button_styles.create_btn, onClick: function () { return handleDeleteType(type); }, children: icons_1.icons.delete })] }, type.id)); }) }), errorMessage && ((0, jsx_runtime_1.jsx)("div", { className: "".concat(form_styles.form_group, " ").concat(form_styles.error), children: errorMessage })), (0, jsx_runtime_1.jsx)("div", { className: form_styles.form_footer, children: (0, jsx_runtime_1.jsx)("button", { "data-testid": "close_modal", type: "button", className: button_styles.create_btn, onClick: function () { return setVisible(false); }, children: "CLOSE" }) })] }) }));
}
exports.default = MechanicsTypeModal;
